import { AccessibilityHelpers } from 'js/components/Util/Accessibility.js';
import { OptimizedResizeInstance } from 'js/components/Util/OptimizedResize.js';
const createFocusTrap = require('focus-trap/index.js');

let accessibilityHelpersInstance = new AccessibilityHelpers();

export class Header {
  constructor(mobileBP = 991) {
    this.headerEl = document.getElementById('Header');
    this.navEl = document.querySelector('.Header-nav');
    this.menuEl = this.headerEl.querySelector('.Header-menu');
    this.menuBtnEl = this.headerEl.querySelector('.Header-toggleIcon');
    this.menuItems = this.headerEl.querySelectorAll('.Header-menuItem a');
    this.hasBeenSetupMobile = false;
    this.mobileBP = window.matchMedia(`(max-width: ${mobileBP}px)`);
    this.wasDesktop = !this.mobileBP.matches;
    this.focusTrap = createFocusTrap('#Header', {
      onActivate: () => {
        this.handleHeaderTabIndexes(0);
      },
      onDeactivate: () => {
        this.handleHeaderTabIndexes(-1);
      },
    });

    this.handleMobileHeader();
  }

  handleMobileHeader() {
    if (this.mobileBP.matches) {
      this.enableMobileHeader();
    }

    OptimizedResizeInstance.on( () => {
      if (this.mobileBP.matches) {
        this.enableMobileHeader();
      } else {
        this.resetMobileHeader();
      }
    });
  }

  enableMobileHeader() {
    const headerLogic = () => {

      document.body.classList.toggle('isOpen');
      accessibilityHelpersInstance.toggleAriaState(this.navEl, 'hidden');
      accessibilityHelpersInstance.toggleAriaState(this.menuBtnEl, 'expanded');
    };

    this.handleHeaderTabIndexes(-1);
    accessibilityHelpersInstance.setAriaProp(this.navEl, 'hidden', true);

    if (!this.hasBeenSetupMobile) {
      this.menuBtnEl.addEventListener('click', headerLogic);
      this.hasBeenSetupMobile = true;
    }
    this.wasDesktop = false;
  }

  resetMobileHeader() {
    if (!this.wasDesktop) {
      document.body.classList.remove('isOpen');
      accessibilityHelpersInstance.setAriaProp(this.navEl, 'hidden', false);
      this.focusTrap.deactivate();
      this.handleHeaderTabIndexes(0);
      this.wasDesktop = true;
    }
  }

  handleHeaderTabIndexes(tabIndex) {
    accessibilityHelpersInstance.setTabIndex(this.menuItems, tabIndex);
  }
}
